import { useState, useEffect } from "react";
// Supabase
import { supabase } from "../supabase/supabase";

export default function useAuthListener() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const init = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        if (error) {
          console.log('[useAuthListener] getSession error', error);
        }
        let user = data?.session?.user || null;
        
        // Fallback: check localStorage if no session
        if (!user) {
          const storedUser = localStorage.getItem('supabase_user');
          if (storedUser) {
            try {
              const parsedUser = JSON.parse(storedUser);
              console.log('[useAuthListener] using stored user from localStorage', parsedUser);
              user = parsedUser;
            } catch (e) {
              console.log('[useAuthListener] failed to parse stored user', e);
              localStorage.removeItem('supabase_user');
            }
          }
        }
        
        console.log('[useAuthListener] init session', { hasSession: !!data?.session, userId: user?.id, email: user?.email });

        if (!mounted) return;
        setUser(user);
        setLoading(false);
      } catch (err) {
        console.error('[useAuthListener] init threw', err);
        if (!mounted) return;
        setUser(null);
        setLoading(false);
      }
    };

    const { data: listener } = supabase.auth.onAuthStateChange(async (event, session) => {
      const user = session?.user || null;
      console.log('[useAuthListener] state change', { event, userId: user?.id, email: user?.email });
      
      if (!mounted) return;
      
      setUser(user);
      setLoading(false);
      
      if (user) {
        // Store user session in localStorage for persistence
        localStorage.setItem('supabase_user', JSON.stringify({
          id: user.id,
          email: user.email,
          user_metadata: user.user_metadata
        }));
      } else {
        // Clear localStorage when user signs out
        localStorage.removeItem('supabase_user');
      }
    });

    init();

    return () => {
      mounted = false;
      try {
        listener?.subscription?.unsubscribe && listener.subscription.unsubscribe();
      } catch (e) {
        // ignore
      }
    };
  }, []);

  return { user, loading };
}
